import axios from 'axios';
import { getToken, removeToken, setToken } from '../helpers/localStorageCache';

const clientUrl = (uri) => {
  const uriPath = uri.startsWith('/') ? uri : `/${uri}`;

  const { hostname } = window.location;
  const subdomain = hostname.split('.')[0];
  // //const region = getToken('region'); manual region entry no longer needed
  const base_url = process.env.REACT_APP_SUBSCRIBER_API
  // const base_url = "portal.api.brandcil-dev.com";
  // const subdomain = 'brandcil'
  // const base_url = 'localhost:8000'

  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    return `https://${subdomain}.${base_url}${uriPath}`;
  }

  return `//${subdomain}.${base_url}${uriPath}`;
};

axios.interceptors.request.use(
  (config) => {
    const token = getToken('jwtToken');
    const newConfig = config;

    newConfig.headers.Authorization = `Bearer ${token}`;

    return newConfig;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config;


    try {
      if (
        error?.response?.status === 401 &&
        originalRequest.url === clientUrl('/resources/api/refresh/')
      ) {
        return Promise.reject(error);
      }
    } catch (e) {

    }

    if (error?.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = getToken('refreshToken');

      return axios
        .post(clientUrl('/resources/api/refresh/'), { refresh: refreshToken })
        .then((res) => {
          if (res.status === 200) {
            setToken('jwtToken', res.data.data.access);
            axios.defaults.headers.common.Authorization = `Bearer ${getToken('jwtToken')}`;
            return axios(originalRequest);
          }
        }).catch(() => {
          //window.location.reload();
          removeToken('jwtToken');
          removeToken('refreshToken');
          window.location.href = '/';
        });
    }
    return Promise.reject(error);
  }
);

const objectToFormData = (obj, form, namespace) => {
  const fd = form || new FormData();
  let formKey;
  const objectKeys = Object.keys(obj);

  objectKeys.forEach((property) => {
    if (namespace) {
      formKey = `${namespace}[${property}]`;
    } else {
      formKey = property;
    }

    const value = obj[property];

    if (Array.isArray(value)) {
      // value is an Array
      arrayToFormData(fd, formKey, value); // eslint-disable-line no-use-before-define
    } else if (typeof value === 'object' && !(value instanceof File)) {
      // value is a nested object
      objectToFormData(value, fd, formKey);
    } else {
      // value is a string or a File object
      fd.append(formKey, value);
    }
  });

  return fd;
};

const arrayToFormData = (fd, formKey, value) => {
  value.forEach((a) => {
    if (typeof a === 'object' && !(a instanceof File)) {
      // elements of array is nested object
      objectToFormData(value, fd, `${formKey}[]`);
    } else {
      // elements of array is string or File object
      fd.append(`${formKey}[]`, a);
    }
  });
};

const buildParam = (params, asJSON = true) => {
  if (asJSON) {
    return JSON.stringify(params);
  }
  return objectToFormData(params);
};

const getDefaultOptions = () => ({ method: 'GET', headers: {} });

function ajax(uri, options = {}, direct = false) {
  let defaultOptions = getDefaultOptions();

  defaultOptions = { ...defaultOptions, method: options.method || defaultOptions.method };
  if (options.data) {
    if (options.formData) {
      defaultOptions.data = buildParam(options.data, false);
    } else {
      defaultOptions.headers['Content-Type'] = 'application/json; charset=UTF-8';
      defaultOptions.data = buildParam(options.data);
    }
  }
  defaultOptions.url = direct ? uri : clientUrl(uri);
  return axios(defaultOptions);
}

export default ajax;
